import backofficeService from './api/backoffice'
const errorSound = new Audio('https://s3.amazonaws.com/4.0image/errorSound.mp3');

export default {
  namespaced: true,
  state: {
    currentUser: null,
    userPreferences: null,
    onlineUserIds: [],
    currentOrganization: null,
    globalStatus: true,
    loginDialog: false,
    loadingStatus: {
      status: false,
      title: 'Please Wait',
    },
    type: null,
  },
  getters: {
    onlineUserIds: (state) => state.onlineUserIds,
    getType(state) {
      return state.type
    },
    loginDialog(state) {
      return state.loginDialog
    },
    globalStatus(state) {
      return state.globalStatus
    },
    loadingStatus(state) {
      return state.loadingStatus
    },
    checkRightStatus: (state) => (id) => {
      let returnValue = false
      // console.log('state.currentUser', state.currentUser, id)
      if (state.currentUser) {
        if (state.currentUser.isAdmin) {
          returnValue = true
        } else {
          if (state.currentUser.userRights) {
            let userRight = state.currentUser.userRights.split(",")
            userRight.map(row => {
              if (Number(row) === id) {
                returnValue = true
              }
            })
          } else {
            returnValue = true
          }

        }
      }


      return returnValue
    },
    currentUser(state) {
      return state.currentUser
    },
    userPreferences(state) {
      return state.userPreferences
    },
    currentOrganization(state) {
      return state.currentOrganization
    },
  },
  actions: {
    setGlobalStatus({
      commit
    }, payload) {
      commit('setGlobalStatus', payload)
    },
    setPageTitle(title) {
      document.title = title
    },
    setLoginDialog({
      commit
    }, payload) {
      commit('setLoginDialog', payload)
    },
    setLoadingStatus({
      commit
    }, payload) {
      commit('setLoadingStatus', payload)
    },
    initType({
      commit
    }) {
      return backofficeService.Api().get('/type')
        .then((response) => {
          commit('initType', response.data)

        })
    },
    initUser({
      commit
    }) {
      return backofficeService.Api().get('/user/current')
        .then((response) => {

          commit('initUser', response.data.data)
          // commit('initOrganization', response.data.organization)
        })
    },
    async loadPreferences({ commit, rootGetters }) {
      try {
        // ✅ Get the current logged-in user from global store
        const currentUser = rootGetters["global/currentUser"];
        if (!currentUser?.id) throw new Error("User not logged in");

        // ✅ API call to backend
        const response = await backofficeService.Api().get(`userSearchPreference/${currentUser.id}`);

        // ✅ Commit to mutation
        commit("loadPreferences", response.data.data);

        // console.log("✅ Preferences loaded:", response.data.data);
        return response.data.data;
      } catch (error) {
        console.error("⚠️ Failed to load preferences:", error);
        return null;
      }
    },
    initOrganization({
      commit
    }, payload) {
      // console.log('initOrganization', payload)
      commit('initOrganization', payload)
    },
  },
  mutations: {
    initType(state, payload) {
      state.type = payload
    },
    setOnlineUsers(state, list) {
      state.onlineUserIds = list;
    },
    setSearch(state, payload) {
      state.search = payload
    },
    initUser(state, payload) {
      state.currentUser = payload
    },
    loadPreferences(state, payload) {
      state.userPreferences = payload
    },
    initOrganization(state, payload) {
      state.currentOrganization = payload
    },
    setGlobalStatus(state, payload) {
      state.globalStatus = payload
    },
    setLoginDialog(state, payload) {
      state.loginDialog = payload
    },
    setLoadingStatus(state, payload) {
      state.loadingStatus = payload
    },
    // initOrganization(state, payload) {
    //   state.currentOrganization = payload
    // },
  },
}